export default {
  paused: false,
  play() {
    this.paused = false;
    return this.paused;
  },
  pause() {
    this.paused = true;
    return this.paused;
  }
};



// WEBPACK FOOTER //
// ./src/game/loops/remoteControl.js